module.exports = __webpack_public_path__ + "static/sport/gallery-thumbs2.8072a8f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Ldp/gallery-thumbs2.jpg
// module id = WR+4
// module chunks = 0